const SET_CAP_DOWN_PAYMENT = 'SET_CAP_DOWN_PAYMENT';
const SET_CAP_TERM = 'SET_CAP_TERM';
const SET_SHOW_CAP = 'SET_SHOW_CAP';
const SET_CAP = 'SET_CAP';


export {
    SET_CAP_DOWN_PAYMENT,
    SET_CAP_TERM,
    SET_SHOW_CAP,
    SET_CAP,
};



// WEBPACK FOOTER //
// ./src/containers/common/cap/constants.js